export default __webpack_public_path__ + "static/media/light-mode-icon-secondary.c7435ab3.svg";